import { createSelector } from '@ngrx/store'
import { selectHasMarkers } from './case/case.selectors'
import { selectionFeature } from './selection/selection.reducer'
import { FreeSelectionsForCase, HierarchicalSelectionsForCase } from './selection/selection.state'

const {
    selectSavedFreeSelections,
    selectSavedHierarchicalSelections,
    selectSavedUnsupervisedSelections,
} = selectionFeature

export const selectShowSelectionLayers = createSelector(
    selectHasMarkers,
    selectSavedFreeSelections,
    (hasMarkers: boolean, selections: FreeSelectionsForCase): boolean =>
        hasMarkers || selections.size > 0
)

export const selectShowHierarchicalSelectionLayers = createSelector(
    selectHasMarkers,
    selectSavedHierarchicalSelections,
    (hasMarkers: boolean, selections: HierarchicalSelectionsForCase): boolean =>
        hasMarkers || selections.size > 0
)

export const selectShowUnsupervisedSelectionLayers = createSelector(
    selectHasMarkers,
    selectSavedUnsupervisedSelections,
    (hasMarkers: boolean, selections: HierarchicalSelectionsForCase): boolean =>
        hasMarkers || selections.size > 0
)
